import { ThemeOptions } from '@mui/material';

const typography: ThemeOptions['typography'] = {
  fontFamily: "'Montserrat', 'Helvetica', 'Arial', 'sans-serif'",
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontFamily: "'Montserrat', 'Helvetica', 'Arial', 'sans-serif'",
    fontWeight: 600,
    fontSize: '6rem',
    lineHeight: 'normal'
  },
  h2: {
    fontFamily: "'Montserrat', 'Helvetica', 'Arial', 'sans-serif'",
    fontWeight: 600,
    fontSize: '3.75rem',
    lineHeight: 'normal'
  },
  h3: {
    fontFamily: "'Montserrat', 'Helvetica', 'Arial', 'sans-serif'",
    fontWeight: 700,
    fontSize: '3rem',
    lineHeight: 'normal'
  },
  h4: {
    fontFamily: "'Montserrat', 'Helvetica', 'Arial', 'sans-serif'",
    fontWeight: 700,
    fontSize: '2.125rem',
    lineHeight: 'normal'
  },
  h5: {
    fontFamily: "'Montserrat', 'Helvetica', 'Arial', 'sans-serif'",
    fontWeight: 700,
    fontSize: '1.5rem',
    lineHeight: 'normal'
  },
  h6: {
    fontFamily: "'Montserrat', 'Helvetica', 'Arial', 'sans-serif'",
    fontWeight: 700,
    fontSize: '1.25rem',
    lineHeight: 'normal'
  },
  subtitle1: {
    fontFamily: "'Montserrat', 'Helvetica', 'Arial', 'sans-serif'",
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: 'normal'
  },
  subtitle2: {
    fontFamily: "'Montserrat', 'Helvetica', 'Arial', 'sans-serif'",
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: 'normal'
  },
  body1: {
    fontFamily: "'Montserrat', 'Helvetica', 'Arial', 'sans-serif'",
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: 'normal'
  },
  body2: {
    fontFamily: "'Montserrat', 'Helvetica', 'Arial', 'sans-serif'",
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 'normal'
  },
  button: {
    fontFamily: "'Montserrat', 'Helvetica', 'Arial', 'sans-serif'",
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: 'normal',
    textTransform: 'uppercase'
  },
  caption: {
    fontFamily: "'Montserrat', 'Helvetica', 'Arial', 'sans-serif'",
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: 'normal',
    textTransform: 'uppercase'
  },
  overline: {
    fontFamily: "'Montserrat', 'Helvetica', 'Arial', 'sans-serif'",
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: 'normal',
    textTransform: 'uppercase'
  }
};

export default typography;
